import { render, staticRenderFns } from "./PerformanceStatisticsReport.vue?vue&type=template&id=7ae13c9f"
import script from "./PerformanceStatisticsReport.vue?vue&type=script&lang=js"
export * from "./PerformanceStatisticsReport.vue?vue&type=script&lang=js"
import style0 from "./PerformanceStatisticsReport.vue?vue&type=style&index=0&id=7ae13c9f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports